import React, { FC, Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import Headline from '../../Elements/Headline'
import LoadingSpinner from '../../Elements/LoadingSpinner'
import BudgetDevelopmentChart from './BudgetDevelopmentChart'
import { Budget } from '../../../lib/Types'

interface Props {
  budget: Budget

}

const BudgetDevelopment: FC<Props> = ({ budget }) => {
  const { t } = useTranslation(['budget'])

  return (
    <>
      <Headline>{t('budget:shared.development')}</Headline>
      <p className='mt-2 mb-5'>{t('budget:budgetDevelopment.description')}</p>
      <Suspense fallback={<LoadingSpinner />}>
        <BudgetDevelopmentChart budget={budget} />
      </Suspense>
    </>
  )
}

export default BudgetDevelopment
